;(function() {
  'use strict'

  angular.module('core.kitsList', [])
})()
